import { Search } from "lucide-react"
import type { ClientTheme } from "@/app/lib/themes"

interface EmptyStateContentProps {
  message: string
  onClear: () => void
  theme: ClientTheme
}

// Shared icon + message + clear-filters block, used inside the table's
// empty row on desktop and standalone in the mobile card layouts.
export function EmptyStateContent({ message, onClear, theme }: EmptyStateContentProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <Search size={24} style={{ color: theme.textDim }} />
      <p
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "14px",
          fontWeight: 500,
          color: theme.textMuted,
        }}
      >
        {message}
      </p>
      <button
        onClick={onClear}
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "12px",
          color: theme.brandAccent,
          background: "none",
          border: "none",
          cursor: "pointer",
          marginTop: "4px",
        }}
      >
        Clear all filters
      </button>
    </div>
  )
}

interface TableEmptyStateProps extends EmptyStateContentProps {
  colSpan: number
}

export function TableEmptyState({ message, onClear, colSpan, theme }: TableEmptyStateProps) {
  return (
    <tr>
      <td colSpan={colSpan} style={{ padding: "48px 20px", textAlign: "center" }}>
        <EmptyStateContent message={message} onClear={onClear} theme={theme} />
      </td>
    </tr>
  )
}
